module.exports = __webpack_public_path__ + "img/insta.6877fc99.png";